/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
$(document).ready(function() {
    
  $.cookie("example", "foo");

  /*setTimeout(function() {
      if($.cookie('tarjscopechoosen') == null)
      {
        $(".choose_tarjscope").trigger('click');
        $.cookie("tarjscopechoosen", "yes", { expires: 1440, path: '/' });
      }

    },0);*/
    alert('aa');
  });

